export enum ActionsRequireVerification {
	signup = 'signup',
	forgotpassword = 'forgotpassword',
	changeemail = 'changeemail',
	changemobilenumber = 'changemobilenumber',
}
export enum VerificationApp {
	none = 'none',
	mobileVerification = 'mobileVerification',
	emailVerification = 'emailVerification',
	ibankTermsAcceptance = 'ibankTermsAcceptance',
	ibankCredentialsReset = 'ibankCredentialsReset',
}

export enum ProfileFields {
	Email,
	PhoneNumber,
}

export enum CookieBarState {
	hidden = 0,
	visible = 1,
}

export enum VerificationTargetWays {
	sms = 0,
	email = 1,
}

export enum GoogleAnalyticsEventCategory {
	InternetBankingLogin = 'Internet Banking Login',
}

export enum GoogleAnalyticsEventAction {
	Continue = 'Συνέχεια',
	Login = 'Σύνδεση',
	CreatePassword = 'Δημιουργία μυστικού κωδικού',
	RetrievePassword = 'Υπηρεσία ανάκτησης μυστικού κωδικού',
	SocialNetworks = 'Social Networks',
}

export enum GoogleAnalyticsEventLabel {
	Continue = 'Συνέχεια',
	Login = 'Σύνδεση',
	CreatePasswordStep1 = 'step 1',
	CreatePasswordStep2 = 'step 2',
	CreatePasswordStep3 = 'step 3',
	RetrievePasswordStep1 = 'step 1',
	RetrievePasswordStep2 = 'step 2',
	RetrievePasswordStep3 = 'step 3',
	RetrievePasswordStep4 = 'step 4',
	RetrievePasswordStep5 = 'step 5',
	Facebook = 'Facebook',
	Twitter = 'Twitter',
	YouTube = 'youtube',
	Linkedin = 'Linkedin',
	Mail = 'mail CC',
}

export enum LoginAction {
	Login,
	LinkUsers,
	SwitchUser,
	RenewLink,
	ImpersonationLogin,
}
export enum LoginType {
	Retail,
	Corporate,
}

export enum ActionBtnId {
	NavigateToOldSite,
	Retry,
	ReturnToClient,
}

export enum OTPReason {
	LinkUser = 'LinkUser',
	SwitchUser = 'SwitchUser',
	RenewLink = 'RenewLink',
	ChangePass = 'ChangePass',
	InitPass = 'InitPass',
}
